import React from 'react';
import { useTranslation } from 'react-i18next';
import tw from 'twin.macro';

import Baiterek from '@/assets/images/BaiterekImage.svg';
import { BigTitle, SubTitle } from '@/components';
import InfoBlock from '@/components/ui/info-block/info-block';

function LandingInfoBlock1() {
  const { t } = useTranslation();

  const Info = [
    {
      title: t('info_landing.info_block_1.block_1.title'),
      caption: t('info_landing.info_block_1.block_1.caption')
    },
    {
      title: t('info_landing.info_block_1.block_2.title'),
      caption: t('info_landing.info_block_1.block_2.caption')
    },
    {
      title: t('info_landing.info_block_1.block_3.title'),
      caption: t('info_landing.info_block_1.block_3.caption')
    },
    {
      title: t('info_landing.info_block_1.block_4.title'),
      caption: t('info_landing.info_block_1.block_4.caption')
    }
  ];

  return (
    <div tw='w-full'>
      <BigTitle
        text={t('info_landing.info_block_1.title')}
        twStyle={tw`sm:text-[34px] text-[24px] text-[#70FF6E] sm:mb-20 mb-10`}
      />
      <div tw='flex flex-col sm:grid grid-cols-2 gap-10 '>
        <div tw='flex flex-col items-center gap-10 text-center'>
          <img src={Baiterek} alt={'Картинка'} tw='max-w-[300px]' />
          <SubTitle text={t('info_landing.info_block_1.image_caption')} twStyle={tw`leading-6`} />
        </div>
        <div tw='flex flex-col justify-between gap-10'>
          <div tw='grid grid-cols-2 col-gap-10 row-gap-10'>
            {Info.map(item => (
              <InfoBlock caption={item.caption} title={item.title} key={item.title} />
            ))}
          </div>
          <SubTitle text={t('info_landing.info_block_1.subtitle')} twStyle={tw`leading-6`} />
        </div>
      </div>
    </div>
  );
}

export default LandingInfoBlock1;
